import * as React from "react"
import {Dialog} from "@headlessui/react"

/**
 * @typedef {object} V3AlertDialogProps
 * @property {boolean} open
 * @property {React.ReactNode} message
 * @property {string} confirmText
 * @property {() => void | Promise<void>} onConfirm
 * @property {number} [zIndex]
 */

/**
 * @type {React.FC<V3AlertDialogProps>}
 */
const V3AlertDialog = ({
  open,
  message,
  confirmText,
  onConfirm,
  zIndex = 10000,
}) => (
  <Dialog
    open={open}
    onClose={() => {}}
    className="fixed inset-0"
    style={{zIndex}}
  >
    <div
      className="absolute inset-0 bg-[#00000080]"
      style={{zIndex: 0}}
      aria-hidden
    />
    <div
      className="absolute inset-0 flex items-center justify-center px-[16px]"
      style={{zIndex: 1}}
    >
      <Dialog.Panel className="flex w-[280px] flex-col items-center rounded-[12px] bg-neutral-white px-[24px] py-[32px]">
        <Dialog.Description className="w-full text-center font-action text-[16px] font-bold leading-[20px] text-neutral-black">
          {message}
        </Dialog.Description>
        <div className="mt-[24px] flex w-full flex-col">
          <button
            type="button"
            className="flex h-[40px] min-h-[40px] w-full items-center justify-center rounded-[24px] bg-neutral-black px-[16px] font-action text-[14px] font-extrabold leading-none text-neutral-white"
            onClick={onConfirm}
          >
            <span className="translate-y-px">{confirmText}</span>
          </button>
        </div>
      </Dialog.Panel>
    </div>
  </Dialog>
)

export default V3AlertDialog
